<!--
 * @Description: 线上测试 -- PC端
 * @Author: xiuwen
 * @Date: 2024-12-25 10:12:23
 * @LastEditors: xiuwen
 * @LastEditTime: 2025-11-19 14:15:34
-->
<template>
	<main class="pc-index">
		<!-- 線上測試輪播 -->
		<div
			v-if="!banners || banners.length === 0"
			class="load-banner"
			:style="{ height: calculatedHeight }"
		></div>
		<Banner :data="banners" :schannel="'calc-banner-pc'" type="onlinecs" v-else />
		<section class="content pc-center-1280">
			<!-- rank -->
			<section class="rank">
				<QuestionRank :isShowCoupon="isShowCouponCesuan" />
				<WeeklyRecommendSection :data="recommend" title="本週推薦" :schannel="'calc-weekly-pc'" />
				<PaidTestSection :data="emotion" title="付費測試" :schannel="'calc-emotion-pc'" />
			</section>
			<!-- 老師測試精選 -->
			<!-- <TeacherSwiper /> -->
			<!-- 主題分類 -->
			<Table :title="'主題分類'" />
			<FreeFunTestSection title="免費趣味測試" />
		</section>
	</main>
</template>

<script setup>
import Banner from "~/components/pc/banner/index.vue";
import { ref, computed } from "vue";
import { getResourse } from "~/api/api";
import { removeDomain } from "~/utils/common";
import PaidTestSection from "./components/paid-test-section/index.vue";
import QuestionRank from "./components/question-rank/index.vue";
import Table from "./components/table.vue";
import FreeFunTestSection from "./components/free-fun-test-section/index.vue";
import TeacherSwiper from "./components/teacher-swiper/index.vue";
import WeeklyRecommendSection from "./components/weekly-recommend-section/index.vue";

defineProps({
	isShowCoupon: {
		type: Boolean,
		default: false,
	},
});

const ratio = 650 / 1920;
const windowWidth = ref(0);
const calculatedHeight = `${windowWidth * ratio}px`;

import { storeToRefs } from "pinia";
import { useUserStore } from "~/stores/user";

const { isLogin, userCouponsData, userCreatedTime } = storeToRefs(useUserStore());

onMounted(() => {
	logEvent("site_calc_uv");
});

const isOldUser = computed(() => {
	return (
		isLogin.value &&
		new Date().getTime() - userCreatedTime.value * 1000 > 7 * 24 * 60 * 60 * 1000 > 0
	);
});

const isShowCouponCesuan = computed(() => {
	return isLogin.value && !userCouponsData.value?.cs_coupon?.is_use && !isOldUser.value;
});

const { data: banners } = await useLazyAsyncData(
	"onlinecs-banners",
	async () => {
		try {
			const res = await getResourse({ class: 98 });
			return res.data.map(v => ({
				...v,
				jump_url: removeDomain(v.actioncontent.global_type),
			}));
		} catch (error) {
			console.error("加载轮播图失败:", error);
			return [];
		}
	},
	{
		default: () => [],
	}
);

// 本周推荐
const { data: recommend } = await useLazyAsyncData(
	"onlinecs-recommend",
	async () => {
		try {
			const res = await getResourse({ class: 100 });
			return res.data.map(v => {
				return {
					...v,
					jump_url: removeDomain(v.actioncontent.global_type),
				};
			});
		} catch (error) {
			console.error("加载数据失败:", error);
			return [];
		}
	},
	{
		default: () => [],
	}
);

// 情感专栏
const { data: emotion } = await useLazyAsyncData(
	"onlinecs-emotion",
	async () => {
		try {
			const res = await getResourse({ class: 99 });
			return res.data.map(v => {
				return {
					...v,
					jump_url: removeDomain(v.actioncontent.global_type),
				};
			});
		} catch (error) {
			console.error("加载数据失败:", error);
			return [];
		}
	},
	{
		default: () => [],
	}
);

// 组件挂载时执行客户端特定逻辑
onMounted(async () => {
	// 设置窗口宽度
	if (import.meta.client) {
		windowWidth.value = window.innerWidth;
	}

	// 埋点事件（仅客户端执行）
	try {
		logEvent("site_calc_uv");
	} catch (error) {
		console.error("埋点事件发送失败:", error);
	}
});
</script>

<style lang="scss" scoped>
.pc-index {
	padding-bottom: 200px;

	.content {
		display: flex;
		flex-direction: column;
		// gap: 60px;

		.rank {
			margin-top: 40px;
			display: flex;
			align-items: flex-start;
			justify-content: center;
			gap: 10px;
			min-height: 642px;
		}
	}
}
</style>
